export * from './featuredOffers502x272';
